

























































































































































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import RegexValidators from '@/shared/regex-validators';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { Prop } from 'vue-property-decorator';
import VerifyAddress from './verify-address.vue';

const cssPrefix = 'edit-address';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwCheckbox,
    VerifyAddress,
  },
})
export default class EditAddress extends SwExtendedVue {
  cssPrefix = cssPrefix;
  display2 = true;
  @Prop({ required : true })
  displayEditAddress : any;
  @Prop({ required : true })
  addressModalProp : any;
  @Prop()
  showFields: any;
  isSubmitted : boolean = false;
  addressChecked : boolean = true;
  emailValidator = new RegExp(RegexValidators.email);
  userNameValidator = new RegExp(RegexValidators.userName);
  useCompanyAddress : boolean = true;
  listOfCountries : any[] = [];
  countryList : any[] = [];
  country = '';
  countryListPersonal : any[] = [];
  countryPersonal = '';
  usStates : any[] = [];
  caStates : any[] = [];
  addressModal : any = {};
  showVerifyAddress : boolean = false;
  verifyData : any = {};
  verifiedCompanyAddress : any;
  inValidPersonalPhone: boolean = false;
  inValidCompanyPhone: boolean = false;
  inValidPersonalPostalCode: boolean = false;
  inValidCompanyPostalCode: boolean = false;

  created() {
    this.addressModal = { ...this.addressModalProp.companyAddress, ...this.addressModalProp.personalAddress, ...this.addressModalProp.useCompanyAsPersonal };
    this.addressChecked = this.addressModalProp.useCompanyAsPersonal;
    console.warn(this.addressModal);
    if (!this.addressModal.companyAddressline2) {
      this.addressModal.companyAddressline2 = '';
    }
    this.loadCountry();
    this.getStateList('US');
    this.getStateList('CA');
    console.warn('val print', this.showFields);
  }

  checkPersonalPostalCode() {
    const regexStr = new RegExp(RegexValidators.postalCode);
    this.inValidPersonalPostalCode = !regexStr.test(this.addressModal.personalPostalCode);
  }
  checkCompanyPostalCode() {
    const regexStr = new RegExp(RegexValidators.postalCode);
    this.inValidCompanyPostalCode = !regexStr.test(this.addressModal.companyPostalCode);
  }
  checkCompanyPhone() {
    const regexStr = new RegExp(RegexValidators.phoneNo);
    this.inValidCompanyPhone = !regexStr.test(this.addressModal.companyPhoneNumber);
  }
  checkPersonalPhone() {
    const regexStr = new RegExp(RegexValidators.phoneNo);
    this.inValidPersonalPhone = !regexStr.test(this.addressModal.personalPhoneNumber);
  }

  loadCountry() {
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/getCountriesFromServer', 'NO')
    .then((response : any) => {
      this.listOfCountries = response.content.lstCountries;
      this.listOfCountries.forEach((ele : any) => {
        const inner : any = {};
        inner['id'] = ele.countryCode;
        inner['label'] =  ele.countryName;
        inner['value'] = ele.countryCode;
        this.countryList.push(inner);
      });
      this.countryListPersonal = [...this.countryList];
      this.countryPersonal = this.countryList.filter((ele : any) => ele.value === this.addressModal.personalCountry)[0].id;
      this.country = this.countryList.filter((ele : any) => ele.value === this.addressModal.companyCountry)[0].id;
      this.$store.commit('stopLoading');
    });
  }
  getStateList(country : any) {
    this.$store
      .dispatch('SnbProfileStoreModule/getStates', { countryCode : country })
      .then((res: any) => {
        console.warn(res);
        if (country === 'CA') {
          this.caStates = res.map((each: any) => {
            return {
              id: each.stateCode,
              label: this.$t(each.stateName),
              value: each.stateCode,
            };
          });
          return;
        }
        this.usStates = res.map((each: any) => {
          return {
            id: each.stateCode,
            label: this.$t(each.stateName),
            value: each.stateCode,
          };
        });
        // this.$store.commit('stopLoading');
      });
  }
  closeDialog() {
    this.$emit('close-modal');
  }
  submit() {
    this.isSubmitted = true;
    if (this.checkValidation()) {
      console.warn('process it');
      const countryFullName = this.countryList.filter((ele : any) => ele.id === this.addressModal.companyCountry)[0].label;
      let stateFullName = '';
      let index = -1;
      if (this.addressModal.companyCountry === 'US') {
        index = this.usStates.findIndex((ele : any) => ele.id === this.addressModal.companyState);
      } else if (this.addressModal.companyCountry === 'CA') {
        index = this.caStates.findIndex((ele : any) => ele.id === this.addressModal.companyState);
      }
      if (index > -1 && this.addressModal.companyCountry === 'US') {
        stateFullName =  this.usStates[index].label;
      }
      if (index > -1 && this.addressModal.companyCountry === 'CA') {
        stateFullName = this.caStates[index].label;
      }

      let companyAddressParams: any = {};
      if (this.showFields === 'all' || this.showFields === 'company') {
        companyAddressParams = {
          countryCode: this.addressModal.companyCountry,
          address2: this.addressModal.companyAddressline2,
          stateCode: this.addressModal.companyCountry === 'US' || this.addressModal.companyCountry === 'CA' ? this.addressModal.companyState : '',
          countryname:  countryFullName,
          statename: stateFullName,
          country : countryFullName,
          city: this.addressModal.companyCity,
          address: this.addressModal.companyAddressline1,
          zipCode: this.addressModal.companyPostalCode,
          state : stateFullName,
          province: this.addressModal.companyCountry === 'US' || this.addressModal.companyCountry === 'CA' ? '' : this.addressModal.companyProvince,
          captchaText : '',
        };
      } else {
        const perCountryFullName = this.countryList.filter((ele : any) => ele.id === this.addressModal.personalCountry)[0].label;
        let perStateFullName = '';
        let perIndex = -1;
        if (this.addressModal.personalCountry === 'US') {
          perIndex = this.usStates.findIndex((ele : any) => ele.id === this.addressModal.personalState);
        } else if (this.addressModal.personalCountry === 'CA') {
          perIndex = this.caStates.findIndex((ele : any) => ele.id === this.addressModal.personalState);
        }
        if (perIndex > -1 && this.addressModal.personalCountry === 'US') {
          perStateFullName =  this.usStates[perIndex].label;
        }
        if (perIndex > -1 && this.addressModal.personalCountry === 'CA') {
          perStateFullName = this.caStates[perIndex].label;
        }
        companyAddressParams = {
          countryCode: this.addressModal.personalCountry,
          address2: this.addressModal.personalAddressline2,
          stateCode: this.addressModal.personalCountry === 'US' || this.addressModal.personalCountry === 'CA' ? this.addressModal.personalState : '',
          countryname:  perCountryFullName,
          statename: perStateFullName,
          country : perCountryFullName,
          city: this.addressModal.personalCity,
          address: this.addressModal.personalAddressline1,
          zipCode: this.addressModal.personalPostalCode,
          state : perStateFullName,
          province: this.addressModal.personalCountry === 'US' || this.addressModal.personalCountry === 'CA' ? '' : this.addressModal.personalProvince,
          captchaText : '',
        };
      }
      this.$store.dispatch('SnbProfileStoreModule/verifyAddress', companyAddressParams)
      .then((response : any) => {
        if (response.msgCode === 'MSWAPP:ADDRESSVERIFICATIONNOTNEEDED') {
          console.warn(companyAddressParams);
          if (this.showFields === 'all' || this.showFields === 'personal') {
            this.verifiedCompanyAddress = companyAddressParams;
            this.returnBasicInfo();
          } else {
            const companyAddressParams = {
              address2: this.addressModal.companyAddressline2,
              country : this.addressModal.companyCountry,
              city: this.addressModal.companyCity,
              address1: this.addressModal.companyAddressline1,
              zipcode: this.addressModal.companyPostalCode,
              state : this.addressModal.companyState,
              province: this.addressModal.companyProvince,
              company: this.addressModal.company,
            };
            this.updateAndCloseAdd(companyAddressParams);
          }
        } else {
          this.$store.commit('stopLoading');
          this.verifyData = {
            enteredAddress: companyAddressParams,
            standardizedAddress: response.content,
            message: response.msgDesc,
            header: response.msgCode === 'MSWAPP:INVALIDADDRESS' ?
            this.$t('verifyaddress.title')
            .toString() : this.$t('profile.editAddress')
            .toString(),
          };
          this.showVerifyAddress = true;
        }
      });
    }
  }
  updateAndCloseAdd(val: any) {
    const payload: any = val;
    payload.phoneno = this.addressModal.companyPhoneNumber;
    payload.mode = 'ORGADDRESS';
    this.$store.dispatch('SnbProfileStoreModule/updateBasicInfo', payload)
    .then((response : any) => {
      if (response.msgCode === 'MSWAPP:SUCCESS') {
        this.$emit('close-address-modal');
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
        this.$store.commit('stopLoading');
      }
    });
  }
  checkValidation() {
    console.warn('called');
    let validateFlag = true;
    if (this.showFields === 'all' || this.showFields === 'company') {
      if (this.addressModal.company.trim().length === 0) {
        validateFlag = false;
      }
      if (this.addressModal.companyPhoneNumber.trim().length === 0) {
        validateFlag = false;
      }
      if (this.addressModal.companyPhoneNumber.trim().length === 0 || this.inValidCompanyPhone) {
        validateFlag = false;
      }
      if (this.addressModal.companyAddressline1.trim().length === 0) {
        validateFlag = false;
      }
      if (this.addressModal.companyCity.trim().length === 0) {
        validateFlag = false;
      }
      if (this.addressModal.companyCountry.trim().length === 0) {
        validateFlag = false;
      }
      if (this.addressModal.companyCountry !== 'CA' &&  this.addressModal.companyCountry !== 'US') {
        if (this.addressModal.companyProvince.trim().length === 0) {
          validateFlag = false;
        }
      }
      if (this.addressModal.companyPostalCode.trim().length === 0 || this.inValidCompanyPostalCode) {
        validateFlag = false;
      }
    }
    if ((!this.addressChecked && this.showFields === 'all') || this.showFields === 'personal') {
      if (this.addressModal.firstName.trim().length === 0) {
        validateFlag = false;
      }
      if (this.addressModal.lastName.trim().length === 0) {
        validateFlag = false;
      }
      // if (this.addressModal.title.trim().length === 0) {
      //   validateFlag = false;
      // }
      if (this.addressModal.personalPhoneNumber.trim().length === 0 || this.inValidPersonalPhone) {
        validateFlag = false;
      }
      if (this.addressModal.personalAddressline1.trim().length === 0) {
        validateFlag = false;
      }
      if (this.addressModal.personalCity.trim().length === 0) {
        validateFlag = false;
      }
      if (this.addressModal.personalCountry.trim().length === 0) {
        validateFlag = false;
      }
      if (this.addressModal.personalCountry !== 'CA' && this.addressModal.personalCountry !== 'US') {
        if (this.addressModal.personalProvince.trim().length === 0) {
          validateFlag = false;
        }
      }
      if (this.addressModal.personalPostalCode.trim().length === 0 || this.inValidPersonalPostalCode) {
        validateFlag = false;
      }
    }
    return validateFlag;
  }
  cancel() {
    this.$emit('close-modal');
  }
  confirmAndClose(result : any) {
    if (this.showFields === 'all' || this.showFields === 'personal') {
      this.verifiedCompanyAddress = result;
      this.returnBasicInfo();
    } else {
      const companyAddressParams = {
        address2: result.address2,
        country : result.countryCode,
        city: result.city,
        address1: result.address,
        zipcode: result.zipCode,
        state : result.stateCode,
        province: result.province,
        company: this.addressModal.company,
      };
      this.updateAndCloseAdd(companyAddressParams);
    }
  }
  returnBasicInfo() {
    let modifiedAddress : any;
    if (this.showFields === 'all') {
      if (this.addressChecked) {
        modifiedAddress = {
          companyName: this.addressModal.company,
          companyAddress: this.verifiedCompanyAddress.address,
          companyAddress1: this.verifiedCompanyAddress.address2,
          companyCity: this.verifiedCompanyAddress.city,
          companyProvince: this.verifiedCompanyAddress.province,
          companyZipCode: this.verifiedCompanyAddress.zipCode,
          companyCountry: this.verifiedCompanyAddress.countryCode,
          companyCountryName: this.verifiedCompanyAddress.country,
          companyState: this.verifiedCompanyAddress.stateCode,
          companyStateName: this.verifiedCompanyAddress.state,
          companyPhone: this.addressModal.companyPhoneNumber,
          companyAddressFlag: true,
          firstName: this.addressModal.firstName,
          lastName: this.addressModal.lastName,
          title: this.addressModal.title,
          personalAddress: this.verifiedCompanyAddress.address,
          personalAddress1: this.verifiedCompanyAddress.address2,
          personalCity: this.verifiedCompanyAddress.city,
          personalProvince: this.verifiedCompanyAddress.province,
          personalZipCode: this.verifiedCompanyAddress.zipCode,
          personalCountry: this.verifiedCompanyAddress.countryCode,
          personalCountryName: this.verifiedCompanyAddress.country,
          personalState: this.verifiedCompanyAddress.stateCode,
          personalStateName: this.verifiedCompanyAddress.state,
          personalPhone: this.addressModal.companyPhoneNumber,
        };
      } else {
        const countryFullName = this.countryList.filter((ele : any) => ele.id === this.addressModal.personalCountry)[0].label;
        let stateFullName = '';
        let index = -1;
        if (this.addressModal.personalCountry === 'US') {
          index = this.usStates.findIndex((ele : any) => ele.id === this.addressModal.personalState);
        } else if (this.addressModal.personalCountry === 'CA') {
          index = this.caStates.findIndex((ele : any) => ele.id === this.addressModal.personalState);
        }
        if (index > -1 && this.addressModal.personalCountry === 'CA') {
          stateFullName =  this.caStates[index].label;
        }
        if (index > -1 && this.addressModal.personalCountry === 'US') {
          stateFullName =  this.usStates[index].label;
        }
        modifiedAddress = {
          companyName: this.addressModal.company,
          companyAddress: this.verifiedCompanyAddress.address,
          companyAddress1: this.verifiedCompanyAddress.address2,
          companyCity: this.verifiedCompanyAddress.city,
          companyProvince: this.verifiedCompanyAddress.province,
          companyZipCode: this.verifiedCompanyAddress.zipCode,
          companyCountry: this.verifiedCompanyAddress.countryCode,
          companyCountryName: this.verifiedCompanyAddress.country,
          companyState: this.verifiedCompanyAddress.stateCode,
          companyStateName: this.verifiedCompanyAddress.state,
          companyPhone: this.addressModal.companyPhoneNumber,
          companyAddressFlag: false,
          firstName: this.addressModal.firstName,
          lastName: this.addressModal.lastName,
          title: this.addressModal.title,
          personalAddress: this.addressModal.personalAddressline1,
          personalAddress1: this.addressModal.personalAddressline2,
          personalCity: this.addressModal.personalCity,
          personalProvince: this.addressModal.personalProvince,
          personalZipCode: this.addressModal.personalPostalCode,
          personalCountry: this.addressModal.personalCountry,
          personalCountryName: countryFullName,
          personalState: this.addressModal.personalState,
          personalStateName: stateFullName,
          personalPhone: this.addressModal.personalPhoneNumber,
        };
      }
    } else {
      const compCountryName = this.countryList.filter((ele : any) => ele.id === this.addressModal.companyCountry)[0].label;
      let companyStateFullName = '';
      let indexCompanyState = -1;
      if (this.addressModal.companyCountry === 'US') {
        indexCompanyState = this.usStates.findIndex((ele : any) => ele.id === this.addressModal.companyState);
      } else if (this.addressModal.companyCountry === 'CA') {
        indexCompanyState = this.caStates.findIndex((ele : any) => ele.id === this.addressModal.companyState);
      }
      if (indexCompanyState > -1 && this.addressModal.companyCountry === 'CA') {
        companyStateFullName =  this.caStates[indexCompanyState].label;
      }
      if (indexCompanyState > -1 && this.addressModal.companyCountry === 'US') {
        companyStateFullName =  this.usStates[indexCompanyState].label;
      }
      modifiedAddress = {
        companyName: this.addressModal.company,
        companyAddress: this.addressModal.companyAddressline1,
        companyAddress1: this.addressModal.companyAddressline2,
        companyCity: this.addressModal.companyCity,
        companyProvince: this.addressModal.companyProvince,
        companyZipCode: this.addressModal.companyPostalCode,
        companyCountry: this.addressModal.companyCountry,
        companyCountryName: compCountryName,
        companyState: this.addressModal.companyState,
        companyStateName: companyStateFullName,
        companyPhone: this.addressModal.companyPhoneNumber,
        companyAddressFlag: false,
        firstName: this.addressModal.firstName,
        lastName: this.addressModal.lastName,
        title: this.addressModal.title,
        personalAddress: this.verifiedCompanyAddress.address,
        personalAddress1: this.verifiedCompanyAddress.address2,
        personalCity: this.verifiedCompanyAddress.city,
        personalProvince: this.verifiedCompanyAddress.province,
        personalZipCode: this.verifiedCompanyAddress.zipCode,
        personalCountry: this.verifiedCompanyAddress.countryCode,
        personalCountryName: this.verifiedCompanyAddress.country,
        personalState: this.verifiedCompanyAddress.stateCode,
        personalStateName: this.verifiedCompanyAddress.state,
        personalPhone: this.addressModal.personalPhoneNumber,
      };
    }
    this.$emit('update-user-detail', modifiedAddress);
    console.warn(modifiedAddress);
  }
}
